import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import { TemplateBuilder } from "./TemplateBuilder";

export function AddTemplate({ onTemplateUpdate }) {
  const [show, setShow] = useState(false);

  return (
    <>
      <Button
        variant="primary"
        className="me-2 w-100"
        onClick={() => setShow(true)}
      >
        Add Template
      </Button>
      <TemplateBuilder
        mode="add"
        show={show}
        onHide={() => setShow(false)}
        onSaved={() => {
          setShow(false);
          onTemplateUpdate();
        }}
      />
    </>
  );
}
